/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	UserCheckPhoneCreateData,
	UserCheckPhoneCreateStatus200,
	UserCheckPhoneCreateStatus400,
	UserCheckPhoneCreateStatus503,
} from "../types/UserCheckPhoneCreate.ts";

function getUserCheckPhoneCreateUrl() {
	const res = { method: "POST", url: `/api/user/check-phone` as const };

	return res;
}

/**
 * @description Запрос ОТП-кода.
 * @summary запрос ОТП
 * {@link /api/user/check-phone}
 */
export async function userCheckPhoneCreate(
	data: UserCheckPhoneCreateData,
	config: Partial<RequestConfig<UserCheckPhoneCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<
		UserCheckPhoneCreateStatus200,
		ResponseErrorConfig<UserCheckPhoneCreateStatus400 | UserCheckPhoneCreateStatus503>,
		UserCheckPhoneCreateData
	>({ method: "POST", url: getUserCheckPhoneCreateUrl().url.toString(), data: requestData, contentType, ...requestConfig });

	return res.data;
}
